<!--
A carousel item, used in the homepage
-->
<template>
    <span class="carouselItem">
        <slot></slot>
    </span>
</template>
<script setup>

</script>
<style lang="scss" scoped>

.itemSelected {
  opacity: 1;
  flex: 1;
}
.itemNotSelected {
  z-index: 1;
  flex: 0 0 auto;
}
</style>
